<template>
  <div class="customer-service">
    <p>
      <strong>Need assistance? We can help!</strong>
    </p>
    <p>
      <span class="customer-service-label">Call Us:</span>
      <a :href="`tel:${customerServiceNumber}`">{{
        customerServiceNumberDisplay
      }}</a>
      {{ customerServiceHoursShort }}
    </p>
    <p>
      <span class="customer-service-label">Email Us:</span>
      <a
        :href="`mailto:${customerServiceEmailOverride || customerServiceEmail}`"
        >{{ customerServiceEmailOverride || customerServiceEmail }}</a
      >
    </p>
    <p v-if="passageOfTitleStatement">
      Please call at
      <a :href="`tel:${customerServiceNumber}`">{{
        customerServiceNumberDisplay
      }}</a>
      {{ customerServiceHoursLong }} if you'd like to arrange your own shipment
      or pickup option.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerServiceFooter',
  props: {
    customerServiceEmailOverride: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters([
      'cart',
      'customerServiceNumber',
      'customerServiceNumberDisplay',
      'customerServiceEmail',
      'customerServiceHoursShort',
      'customerServiceHoursLong',
    ]),
    passageOfTitleStatement() {
      return this.cart.passage_of_title_statement
    },
  },
}
</script>

<style scoped></style>
